export default __webpack_public_path__ + "static/media/SOCIALSECURITYCERTIFICATE.0b26c4ae.png";